<template>
  <div id="app">
    <nav-bar>
      <router-view></router-view>
      <vue-progress-bar></vue-progress-bar>
    </nav-bar>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Nav from './components/Nav'
export default {
  name: 'App',
  components: {
    // HelloWorld
    'nav-bar': Nav
  }
}
</script>

<style>
</style>
